export default {
  loginSuccess (state, payload) {
    state.authentication = payload
  },
  addUserProfile (state, payload) {
    state.authentication = { ...state.authentication, ...payload }
  }
}
